goog.provide("shadow.js.shim.module$src$svg$mathematical$chart_bar_horizontal_svg$default");
shadow.js.shim.module$src$svg$mathematical$chart_bar_horizontal_svg$default = shadow.js.shim.module$src$svg$mathematical$chart_bar_horizontal_svg.default;
